import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { IntroStatement } from "@/components/sections/IntroStatement";
import { About } from "@/components/sections/About";
import { Team } from "@/components/sections/Team";
import { Manifesto } from "@/components/sections/Manifesto";
import { Services } from "@/components/sections/Services";
import { Pricing } from "@/components/sections/Pricing";
import { PriceTables } from "@/components/sections/PriceTables";
import { ContactCTA } from "@/components/sections/ContactCTA";

export default function Home() {
  return (
    <div className="bg-navy">
      <Header />
      <Hero />
      <IntroStatement />
      <About />
      <Team />
      <Manifesto />
      <Services />
      <Pricing />
      <PriceTables />
      <ContactCTA />
      <Footer />
    </div>
  );
}
